<template>
  <nav class="c-category-menu">
    <transition
      :name="`slide-${slideDirection}`"
      mode="out-in"
    >
      <div
        :key="selectedCategory && selectedCategory.slug"
        class="c-category-menu__block"
        :class="{ '-returnable': !!selectedCategory }"
      >
        <span class="c-category-menu__title">
          <template v-if="!selectedCategory">
            Departamentos
          </template>
          <template v-else>
            <button
              class="c-category-menu__back"
              @click="back"
            >
              <vIcon
                name="arrow-left"
                color="primary"
              />
            </button>

            {{ selectedCategory.name }}
          </template>
        </span>

        <ul class="c-category-menu__list">
          <li
            v-if="selectedCategory"
            class="c-category-menu__item"
          >
            <a
              class="c-category-menu__link-subcategory"
              :href="categoryLink(selectedCategory)"
              :data-testid="`button-bar-category-${selectedCategory.slug}`"
            >
              Tudo de {{ selectedCategory.name }}
            </a>
          </li>

          <category-menu-item
            v-for="item in visibleCategories"
            :key="item.slug"
            :name="item.name"
            :slug="item.slug"
            :has-children="!!item.children.length"
            :path="categoryLink(item)"
            :is-selected="isSelected(item.slug)"
            @select="select"
          />

          <li
            v-if="!selectedCategory"
            class="c-category-menu__item has-children"
          >
            <a
              class="c-category-menu__link"
              href="/enjoei-pro"
              data-testid="button-bar-category-enjoei-pro"
              @click="registerInteraction('pro')"
            >
              enjoei pro
            </a>
          </li>
        </ul>
      </div>
    </transition>
  </nav>
</template>

<script>
  import vIcon from '@/web/components/icon.vue'
  import CategoryMenuItem from './category-menu/item.vue'

  import { PRODUCTS_SEARCH_CONTEXT } from '@/tools/constants/contexts-for-metrics'
  import { pushInteraction } from '@/tools/data-layer/data-layer'

  export default {
    components: {
      CategoryMenuItem,
      vIcon
    },
    props: {
      tree: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        selected: [],
        slideDirection: 'left',
        searchCategoriesRef: PRODUCTS_SEARCH_CONTEXT.SEARCH_CATEGORIES_MENU
      }
    },
    computed: {
      visibleCategories() {
        if (!this.selected.length) {
          return this.tree
        }

        return this.selected.reduce((list, slug) => {
          return (
            list.find((category) => slug === category.slug).children || list
          )
        }, this.tree)
      },
      selectedCategory() {
        if (!this.selected.length) {
          return null
        }

        const itemCategory =  this.selected.reduce((list, slug, index) => {
          const category = list.find((category) => slug === category.slug)

          return index === this.selected.length - 1
            ? category
            : category.children
        }, this.tree)

        return itemCategory
      }
    },
    methods: {
      isSelected(category) {
        return this.selected.indexOf(category) > -1
      },
      select(category) {
        this.slideDirection = 'left'
        this.selected.push(category)
      },
      back() {
        this.slideDirection = 'right'
        this.selected.pop()
      },
      registerInteraction(content) {
        pushInteraction({ context: 'header_mobile', type: 'click', content })
      },
      categoryLink(category) {
        let [pathname, query] = category.path.split('?')
        if(query) return `${pathname}?${query}&ref=${this.searchCategoriesRef}`
        return `${pathname}?ref=${this.searchCategoriesRef}`
      }
    }
  }
</script>

<style lang="scss">
  .c-category-menu {
    $root: &;

    margin: -20px;
    padding: 48px 20px;
    line-height: 50px;
    font-weight: $font-weight-regular;

    &__title {
      text-transform: lowercase;
      display: flex;
      font-size: 16px;
      line-height: 24px;
      font-weight: $font-weight-bold;
      color: $color-neutral-900;
      margin-bottom: 16px;
    }

    &__back {
      margin-right: 10px;
      margin-top: -2px;
    }

    &__block {
      width: 100%;
      min-width: #{275px - 20px};

      &.-returnable {
        #{$root}__list {
          padding-left: 35px;
        }
      }

      &.slide-right-enter-active,
      &.slide-left-enter-active,
      &.slide-right-leave-active,
      &.slide-left-leave-active {
        transition: transform .175s cubic-bezier(.75, 0, .25, 1);
      }

      &.slide-left-enter {
        transform: translateX(100%);
      }

      &.slide-left-leave-to {
        transform: translateX(-100%);
      }

      &.slide-right-enter {
        transform: translateX(-100%);
      }

      &.slide-right-leave-to {
        transform: translateX(100%);
      }
    }

    &__item {
      display: flex;
      width: 100%;
      padding-top: 16px;
      padding-bottom: 16px;
    }

    &__link {
      text-transform: lowercase;
      flex: none;
      width: 100%;
      color: $color-neutral-900;
      font-size: 16px;
      font-weight: $font-weight-medium;
      line-height: 24px;
      position: relative;

      &:hover {
        color: $color-primary;
      }

      &-subcategory {
        text-transform: lowercase;
        flex: none;
        width: 100%;
        color: $color-neutral-900;
        font-size: 16px;
        font-weight: $font-weight-medium;
        line-height: 24px;
        position: relative;
        color: $color-primary;
      }

      .o-icon {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
</style>
